module.exports = __webpack_public_path__ + "static/media/RecomendaMini.6ea37af9.png";